import { createFileRoute, redirect } from "@tanstack/react-router";
import { RegisterTemplate } from "~/features/auth/RegisterTemplate";
import { useAuthStore } from "~/stores/useAuthStore";

/**
 * `/signup` は `/register` のエイリアス。
 * Hokage 等のネイティブアプリは `/signup?app=native&appId=...` を起動時に開くため、
 * Utage-Web 互換のため新規登録ページをここでも提供する。
 */
export const Route = createFileRoute("/signup")({
  beforeLoad: () => {
    const token = useAuthStore.getState().token;
    if (token) {
      throw redirect({ to: "/discover" });
    }
  },
  component: RegisterTemplate,
});
